import React, { useState, useEffect } from 'react'
import moment, { duration } from 'moment'
import './Timer.scss'

const Timer = ({ data, className, style }) => {
    const [isVisible, setIsVisible] = useState(true)

    const [days, setDays] = useState(0)
    const [hours, setHours] = useState(0)
    const [minutes, setMinutes] = useState(0)
    const [seconds, setSeconds] = useState(0)

    let interval = null
    const setCountdown = () => {
        setIsVisible(true)
        const currentTime = moment().format()
        const timerFinish = moment(data?.timer_date).format()
        const clockDuration = duration(moment(timerFinish).diff(currentTime))

        const days = clockDuration?.days()
        const hours = clockDuration?.hours()
        const minutes = clockDuration?.minutes()
        const seconds = clockDuration?.seconds()

        if (days < 1 && hours < 1 && minutes < 1 && seconds < 1) {
            setDays(0)
            setHours(0)
            setMinutes(0)
            setSeconds(0)

            setIsVisible(false)

            clearInterval(interval)
        }
        setDays(days)
        setHours(hours)
        setMinutes(minutes)
        setSeconds(seconds)
    }

    useEffect(() => {
        setCountdown()

        interval = setInterval(() => {
            setCountdown()
        }, 1000)

        return () => clearInterval(interval)
    }, [data?.timer_date])

    return (
        <>
            {data?.is_timer && isVisible && (
                <div className={"timer " + className} style={style}>
                    <div className="timer-title">{ data.timer_title|| 'Предложение актуально еще: '}</div>
                    <div className="timer-countdown flex">
                        {days > 0 && <div className="countdown-block">
                            <div className="time hour ">{days}д. </div>
                        </div>}
                        <div className="countdown-block">
                            <div className="time hour ">{hours.toString().length < 2 ? '0' + hours : hours}:</div>
                        </div>
                        <div className="countdown-block">
                            <div className="time minute">{minutes.toString().length < 2 ? '0' + minutes : minutes}:</div>
                        </div>
                        <div className="countdown-block">
                            <div className="time second">{seconds.toString().length < 2 ? '0' + seconds : seconds}</div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Timer
